<script lang="ts">
	import TableCell from 'components/Table/TableCell/TableCell.svelte';
	import TableRow from 'components/Table/TableRow/TableRow.svelte';
	import NoIcon from 'assets/svg/noCoinIcon.svg?url';
	import { onErrorCoinLogo } from 'utils/onErrorCoinLogo';
	import type { IFormattedMarket } from 'customTypes/exchange';
	import formatNumber from 'utils/formatNumber';
	import activeCurrency from 'stores/activeCurrency';
	import formatCoinPrice from 'utils/formatCoinPrice';
	import PriceTooltip from 'components/PriceTooltip/PriceTooltip.svelte';

	export let dark = false;
	export let data: IFormattedMarket;
	export let filterType: string;
	export let orderNumber: number;
	let price: { initial: string; formatted: string };
	let depth_up: string;
	let depth_down: string;

	const img = (data?.image?.length && data.image) || NoIcon;

	$: if (data) {
		price = formatCoinPrice(
			formatNumber(data?.price * $activeCurrency.price, $activeCurrency.currency),
		);
		depth_up =
			filterType === 'spot'
				? formatNumber(data?.depth_up_usd * $activeCurrency.price, $activeCurrency.currency)
				: `${formatNumber(data?.funding_rate || 0, $activeCurrency.currency, false, 'decimal')}%`;
		depth_down =
			filterType === 'spot'
				? formatNumber(data?.depth_down_usd * $activeCurrency.price, $activeCurrency.currency)
				: `${formatNumber(data?.spread || 0, $activeCurrency.currency, false, 'decimal')}%`;
	}
</script>

<TableRow {dark} class="market-table-row" withHover={false}>
	<TableCell {dark} class="market-rank">
		{orderNumber}
	</TableCell>
	<TableCell {dark} class="market-name">
		<div class="center">
			<img
				class="market-icon"
				src={img}
				alt={`${data?.name} logo`}
				loading="lazy"
				on:error={onErrorCoinLogo}
			/>
			<p class="name tablet">{data?.name ?? data?.base}</p>
			<div class="mobile-view">
				<p class="name">{data?.name ?? data?.base}</p>
				<div class="pair-wrapper">
					<p class="rank" class:dark>{orderNumber}</p>
					<p class="pair">{data?.pair}</p>
				</div>
			</div>
		</div>
	</TableCell>
	<TableCell {dark} class="market-pair">{data?.pair}</TableCell>

	<TableCell {dark} class="market-price">
		<PriceTooltip {price} />
	</TableCell>
	<TableCell {dark} class="market-depth-plus">{depth_up}</TableCell>
	<TableCell {dark} class="market-depth-minus">{depth_down}</TableCell>
	<TableCell {dark} class="market-volume"
		>{formatNumber(data?.volume * $activeCurrency.price, $activeCurrency.currency)}</TableCell
	>
</TableRow>

<style lang="scss">
	@import './marketsTableRow.scss';
</style>
